import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const PersonalInfoSection = ({ formData, isEditing, onInputChange }) => {
  const idTypes = [
    { value: 'CC', label: 'Cédula de Ciudadanía' },
    { value: 'CE', label: 'Cédula de Extranjería' },
    { value: 'PA', label: 'Pasaporte' },
    { value: 'TI', label: 'Tarjeta de Identidad' }
  ];

  const formatPhoneNumber = (value) => {
    const cleaned = value?.replace(/\D/g, '');
    if (cleaned?.startsWith('57')) {
      const number = cleaned?.slice(2);
      if (number?.length <= 3) return `+57 ${number}`;
      if (number?.length <= 6) return `+57 ${number?.slice(0, 3)} ${number?.slice(3)}`;
      return `+57 ${number?.slice(0, 3)} ${number?.slice(3, 6)} ${number?.slice(6, 10)}`;
    }
    return value;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
          <Icon name="User" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Información Personal</h2>
          <p className="text-sm text-muted-foreground">Actualiza tus datos personales</p>
        </div>
      </div>

      <div className="space-y-4">
        {/* Full Name */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Nombre Completo *
          </label>
          <Input
            type="text"
            value={formData?.fullName}
            onChange={(e) => onInputChange('fullName', e?.target?.value)}
            disabled={!isEditing}
            placeholder="Ingresa tu nombre completo"
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Correo Electrónico *
          </label>
          <Input
            type="email"
            value={formData?.email}
            onChange={(e) => onInputChange('email', e?.target?.value)}
            disabled={!isEditing}
            placeholder="correo@ejemplo.com"
          />
          {isEditing && (
            <p className="text-xs text-muted-foreground mt-1">
              Cambiar tu correo requerirá verificación
            </p>
          )}
        </div>

        {/* Phone */}
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Teléfono *
          </label>
          <Input
            type="tel"
            value={formData?.phone}
            onChange={(e) => onInputChange('phone', formatPhoneNumber(e?.target?.value))}
            disabled={!isEditing}
            placeholder="+57 312 456 7890"
          />
        </div>

        {/* ID Type and Number */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Tipo de Identificación *
            </label>
            <Select
              value={formData?.idType}
              onChange={(e) => onInputChange('idType', e?.target?.value)}
              disabled={!isEditing}
              options={idTypes}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Número de Identificación *
            </label>
            <Input
              type="text"
              value={formData?.idNumber}
              onChange={(e) => onInputChange('idNumber', e?.target?.value)}
              disabled={!isEditing}
              placeholder="1234567890"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfoSection;